type CampaignItem = {
  id: number;
  announcement: string;
  dDayLabel?: string;
  dDayStatus?: "upcoming" | "today" | "recent" | "closed" | "expired";
  [key: string]: any;
};

const filterAndSortCampaigns = (data: CampaignItem[]): CampaignItem[] => {
  const now = new Date();

  const parseDate = (dateStr: string): Date => {
    const [yy, mm, dd] = dateStr.split("-").map(Number);
    return new Date(2000 + yy, mm - 1, dd);
  };

  const truncateTime = (date: Date) =>
    new Date(date.getFullYear(), date.getMonth(), date.getDate());

  const today = truncateTime(now);

  const enriched = data
    .map((item) => {
      const announcementDate = truncateTime(parseDate(item.announcement));
      const diff = Math.floor(
        (announcementDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24)
      );

      let dDayLabel = "";
      let dDayStatus: CampaignItem["dDayStatus"] = "upcoming";

      if (diff > 0) {
        dDayLabel = `D-${diff}`;
        dDayStatus = "upcoming";
      } else if (diff === 0) {
        dDayLabel = "D-DAY";
        dDayStatus = "today";
      } else if (diff < -5){
        dDayLabel = "마감됨";
        dDayStatus = "closed";      }
      else {
        dDayStatus = "expired";
      }

      return { ...item, dDayLabel, dDayStatus };
    })
    .filter((item) => item.dDayStatus !== "expired");

  const sorted = enriched.sort((a, b) => {
    const dateA = parseDate(a.announcement);
    const dateB = parseDate(b.announcement);

    const isPastA = dateA.getTime() < now.getTime();
    const isPastB = dateB.getTime() < now.getTime();

    if (!isPastA && !isPastB) {
      return dateA.getTime() - dateB.getTime();
    }

    if (isPastA && isPastB) {
      return dateA.getTime() - dateB.getTime();
    }

    return isPastA ? 1 : -1;
  });

  return sorted;
};

export default filterAndSortCampaigns;
